const f = {
  color: {
    background: "#ffffffff",
    label: {
      text: "#405261ff"
    },
    itemMain: {
      text: "#314351ff"
    },
    itemSecondary: {
      text: "#556575ff"
    }
  }
};
export {
  f as formField
};
